import { FormBuilderData, FormBuilderFieldCheckbox } from 'types/formBuilder';

export const useChecklistLogic = (checklistData: FormBuilderData): FormBuilderFieldCheckbox[] => {
  const groupStatuses = checklistData.form ?? [];

  return groupStatuses as FormBuilderFieldCheckbox[];
};
